<template>
    <div id="app" class="wrap no_side" v-loading="loading">
        <page-header v-if="!noHeader" :type="type"></page-header>
        <router-view/>
    </div>
</template>

<script>
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";

export default {
    name: "App",
    mixins: [],
    components: {},
    provide() {
        return {
            changeLoading: this.changeLoading,
        }
    },
    props: {},
    data() {
        return {
            passPath: ['/auth'],
            loading: false,
            type: 'blockchain'
        }
    },
    created() {
        this.$store.dispatch('itemCategory/setItemCategory', {});
        this.$store.dispatch('competitionCategory/setCompetitionCategory', {});
        if (!util.isEmpty(this.$route.meta.showOption) && this.$route.meta.showOption.hasOwnProperty('blockchain')) {
            this.type = 'blockchain';
        }
    },
    mounted() {
        EventBus.$on('changeLoading', this.changeLoading)
        EventBus.$on('apiLoading', this.changeLoading)
    },
    beforeDestroy() {
        EventBus.$off('changeLoading')
        EventBus.$off('apiLoading')
    },
    destroyed() {
    },
    computed: {
        noHeader() {
            return this.$route.meta.noHeader ? this.$route.meta.noHeader : false;
        },
    },
    methods: {
        changeLoading(value) {
            this.loading = value;
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve(true);
                }, 50)
            })
        },
    },
    watch: {},
}
</script>

<style lang="scss">
@import "./assets/scss/index.scss";

</style>
